// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"9a82ff44","430":"50dae19a","472":"d02ce909","746":"35e355b7","798":"1370985b"}[chunkId] + ".chunk.css";
};